import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { PromotionProduct, PromotionProductsData } from '@evermile/customer-tracking';

@Component({
  selector: 'common-promotion-products',
  templateUrl: './promotion-products.component.html',
  styleUrls: ['./promotion-products.component.scss'],
})
export class PromotionProductsComponent implements OnInit, OnDestroy, OnChanges {
  @Input({ required: true }) brandColor!: string;
  @Input() contained?: boolean;
  @Input({ required: true }) textColor!: string;
  @Input({ required: true }) data!: PromotionProductsData;
  @Input({ required: true }) orderStatus?: string;
  @Input() promotionCode?: string;
  @Input() fabVariant?: boolean;
  @Input() discountPercent?: number;
  utmPrefix = 'utm_medium=order-tracking&utm_campaign=evermile-featrued-products&utm_source=evermile&evrm-promotion=';
  isMobileMode = false;
  urlLoadedMap: Map<string, boolean> = new Map<string, boolean>();
  isEmptyState = false;
  emptyData: PromotionProduct[] = [
    {
      title: 'Product name',
      link: '',
      imageUrl: '',
    },
    {
      title: 'Product name',
      link: '',
      imageUrl: '',
    },
    {
      title: 'Product name',
      link: '',
      imageUrl: '',
    },
    {
      title: 'Product name',
      link: '',
      imageUrl: '',
    },
  ];

  //Subs
  subMobileMode?: Subscription;

  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit() {
    this.subMobileMode = this.breakpointObserver.observe(['(max-width: 460px)']).subscribe((result) => {
      this.isMobileMode = result.matches;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      if (!this.data?.promotionProducts?.length && this.contained) {
        this.isEmptyState = true;
        this.data.promotionProducts = this.emptyData;
      } else {
        this.isEmptyState = false;
      }
    }
    if (changes['promotionCode'] && this.promotionCode) {
      this.editFeaturedProductsLink();
    }
  }

  editFeaturedProductsLink() {
    this.data?.promotionProducts?.forEach((product) => {
      product.link = this.getProductLink(product.link);
    });
    if (this.data?.promotionButton?.link) {
      this.data.promotionButton.link = this.getProductLink(this.data?.promotionButton?.link);
    }
  }

  ngOnDestroy() {
    this.subMobileMode?.unsubscribe();
  }

  getProductLink(link: string) {
    return link?.includes('?')
      ? `${link}&${this.utmPrefix}${this.promotionCode}`
      : `${link}?${this.utmPrefix}${this.promotionCode}`;
  }

  isUrlLoaded(url: string): boolean {
    return this.urlLoadedMap.get(url) || false;
  }

  setUrlLoaded(url: string) {
    this.urlLoadedMap.set(url, true);
  }

  handleMissingImage(event: ErrorEvent, missingUrl: string) {
    const imgElement = event.target as HTMLImageElement;
    const parent = imgElement.parentElement;
    if (parent) parent.style.display = 'none';
    this.setUrlLoaded(missingUrl);
  }

  protected readonly PromotionProductsData = PromotionProductsData;
}
